import React from "react";
import {withSnackbar, WithSnackbarProps} from "notistack";
import {Redirect, RouteComponentProps} from "react-router-dom";
import {Box} from "@mui/material";
import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import {EditUserState} from "./models";
import {User} from "models";
import {ErrorResponseApi} from "models/response";
import {t} from "@lingui/macro";
import CreateAndEditUser from "components/backoffice/user/create-and-edit-user/create-and-edit-user";
import UserService from "services/user-service";
import { UpdateUserRequest } from "models/request";

class EditUser extends React.Component<WithSnackbarProps & RouteComponentProps<any>, EditUserState> {

    constructor(props: any) {
        super(props);

        this.state={
            isLoading: true,
            user: null,
            userError: false
        }
    }

    componentDidMount() {
        this.getUser();
    }

    private getUser = () => {
        this.setState(() => ({
            isLoading: true
        }))
        UserService.getUserById(this.props.match.params.id, this.getUserSuccessCallback, this.getUserErrorCallback);
    }

    getUserSuccessCallback = (data: User) => {
        this.setState(() => ({
            user: data,
            isLoading: false
        }))
    }

    getUserErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            userError: true,
            isLoading: false
        }))
    }

    private checkRequest = (request: UpdateUserRequest): boolean => {

        let errorsArray: string[] = [];

        if(request.name === "" || !request.name)
            errorsArray.push(t({
                id: "eu-no-name-edit-user",
                message: "È necessario inserire il nome"
            }));

        if(request.surname === "" || !request.surname)
            errorsArray.push(t({
                id: "eu-no-surname-edit-user",
                message: "È necessario inserire il cognome"
            }));

        if(request.email === "" || !request.email)
            errorsArray.push(t({
                id: "eu-no-email-edit-user",
                message: "È necessario inserire la mail"
            }));

        if(!request.role)
            errorsArray.push(t({
                id: "eu-no-role-edit-user",
                message: "È necessario inserire il ruolo"
            }));

        if (errorsArray.length > 0)
            this.props.enqueueSnackbar(errorsArray.join(". "),
                { variant: "error" });

        return errorsArray.length === 0;
    }


    private submitForm = (request: UpdateUserRequest) => {
        if(!this.checkRequest(request))
            return

        this.setState(() => ({
            isLoading: true
        }))
        
        UserService.updateUser(this.state.user!.id, request, this.EditUserSuccessCallback, this.EditUserErrorCallback);
    };


    EditUserSuccessCallback = (data: any) => {
        this.setState(() => ({
            isLoading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "eu-success-edit-user",
            message: "I dati dell'utente sono stati aggiornati"
        }), {
            variant: "success",
        })

        this.getUser();
    }

    EditUserErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
        }));

        this.props.enqueueSnackbar(t({
            id: "eu-error-edit-user",
            message: "Si è verificato un errore. Non è stato possibile aggiornare i dati dell'utente"
        }), {
            variant: "error",
        });
    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack/>
                {this.state.userError && <Redirect to={"/not-found"} />}
                {!this.state.userError && 
                    <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                        {!this.state.isLoading &&
                            <CreateAndEditUser
                                user={this.state.user}
                                onSubmit={this.submitForm}
                            />
                        }
                    </Box>}
            </Box>
        );
    }
}

export default withSnackbar(EditUser);